import React, { Component, Fragment } from "react";
import { Form } from "react-bootstrap";
import { Dropdown } from "semantic-ui-react";
import AlertNoPermission from "../../alerts/AlertNoPermission";

class GroupsDropdown extends Component {
    state = { groupsList: [], noPermission: false };

    getGroup = async () => {
        const { fetchURL, onShowAlert, t } = this.props;
        onShowAlert("");
        try {
            const response = await fetch(`${fetchURL}/groups-list-dropdown`, {
                credentials: "include",
                method: "POST",
            });
            if (response.status === 200) {
                await response.json().then((fetchedData) => {
                    //console.log(fetchedData);
                    if (fetchedData.status === "noPermission") this.setState({ noPermission: true });
                    else if (fetchedData.status === "notLogged") this.props.onShowHomePage();
                    else if (fetchedData.status === false) this.setState({ groupsList: null });
                    else this.setState({ groupsList: fetchedData.groupsList });
                });
            } else {
                onShowAlert({ variant: "danger", message: response.status });
            }
        } catch (err) {
            onShowAlert({ variant: "danger", message: `${t("error.cannotFetchData")} (${err})` });
            this.setState({ loading: false });
        }
    };

    componentDidMount() {
        this.getGroup();
    }

    render() {
        const { groupsList, noPermission } = this.state;
        const { defaultValue, txtLabel, onPartGroupSelected, t } = this.props;
        return (
            <Fragment>
                <Form.Label>{txtLabel}</Form.Label>
                {noPermission ? (
                    <AlertNoPermission t={t} />
                ) : (
                    <Fragment>
                        {groupsList === null ? (
                            <p className="mt-2 opacity-4">{t("group.noVerifiedGroup")}</p>
                        ) : (
                            <Dropdown
                                defaultValue={defaultValue}
                                id="groupDropdown"
                                className="mb-3"
                                placeholder={t("group.clickChooseGroup")}
                                fluid
                                clearable
                                selection
                                options={groupsList}
                                onChange={(event, { value }) => {
                                    onPartGroupSelected(event, value);
                                }}
                            />
                        )}
                    </Fragment>
                )}
            </Fragment>
        );
    }
}

export default GroupsDropdown;
